import { Component, OnInit, Input, OnChanges, Output, EventEmitter } from '@angular/core';
import { AgenteFinanceiro } from 'src/app/model/agente-financeiro.model';
import { AgenteFinanceiroService } from 'src/app/shared/services/agente-financeiro.service';
import { LimiteAgenteFinanceiro } from 'src/app/model/limite-agente-financeiro.model';
import { BnLoadingService } from "@bndes/bndes-ux4/bndes-angular-utils";

import moment from "moment";
import { LimiteAporteService } from 'src/app/shared/services/limite-aporte.service';
import { LimiteAportado } from 'src/app/model/limite-aportado.model';

@Component({
    selector: 'app-limite-contratacao-listagem',
    templateUrl: './limite-contratacao-listagem.component.html',
    styleUrls: ['./limite-contratacao-listagem.component.scss'],
    standalone: false
})
export class LimiteContratacaoListagemComponent implements OnInit, OnChanges {

  @Input() agenteFinanceiro: AgenteFinanceiro;
  @Input() refresh: any;
  @Input() limpar: any;
  @Output() public exportarLista: EventEmitter<any> = new EventEmitter<any>();

  public limites: LimiteAportado[];
  public dataLimites: string = undefined;

  constructor(private limiteAporteService: LimiteAporteService,
    private loadingService: BnLoadingService) {
  }

  ngOnInit() {
   
  }

  ngOnChanges(changesObj) {
    if (changesObj.refresh) {
      this.buscaLimites();
    } else if (changesObj.limpar) {
      this.limites = [];
    }
  }

  private buscaLimites() {
      this.loadingService.bloqueiaTela();

      this.limiteAporteService.getLimites(this.agenteFinanceiro?.id).subscribe((resp) => {
        this.limites = resp;
        this.dataLimites = moment().format('YYYY-MM-DD HH:mm:ss');
        this.loadingService.liberaTela();
      });
  }

  getDestaqueLimite(limite: LimiteAportado): string {
    let cssClass:string = '';

    if (limite.valorDisponivel < 0.00) {
      cssClass += ' texto-destaque';
    }

    return cssClass.trim();
  }

  btnExportarLista() {
    this.exportarLista.emit(null);
  }

  exibeListagem() {
    return this.limites && this.limites?.length && !this.limites.every(limite => limite.comprometido == 0 && 
      limite.comprometidoLegado == 0 &&
      limite.valorDisponivel == 0 &&
      limite.valorSubscrito == 0 &&
      limite.valorLimiteGarantia == 0);
  }
}
